import React from 'react';
import styled from '@emotion/styled';
import { Trash } from '@phosphor-icons/react';
import { Trans } from '@lingui/macro';
import { colors } from 'styles/theme/colors';

type ClearedFieldIndicatorProps = {
  onClick?: () => void;
  /** Field name to display, e.g. "Brand will be set to empty" */
  fieldName?: string;
};

export const ClearedFieldIndicator = ({ onClick, fieldName }: ClearedFieldIndicatorProps) => {
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if ((e.key === 'Enter' || e.key === ' ') && onClick) {
      e.preventDefault();
      onClick();
    }
  };

  return (
    <Container
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={onClick ? handleKeyDown : undefined}
    >
      <Trash size={20} color={colors.error[400]} />
      <span>
        {fieldName ? (
          <Trans>{fieldName} will be set to empty</Trans>
        ) : (
          <Trans>This field will be set to empty</Trans>
        )}
      </span>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  height: 44px;
  padding: 10px 14px;
  border-radius: 8px;
  border: 0.5px solid ${p => p.theme.palette.border.errorSolid};
  background: ${p => p.theme.palette.bg?.primary ?? '#fff'};
  color: ${p => p.theme.palette.text.error};
  font-family: ${p =>
    p.theme.typography.bodyMd?.fontFamily ?? p.theme.typography.bodySm.fontFamily};
  font-size: 16px;
  font-weight: 400;
  line-height: 1.5rem;
  cursor: ${p => (p.onClick ? 'pointer' : 'not-allowed')};
  box-sizing: border-box;
  width: 100%;
  white-space: nowrap;
`;
